import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

import { RootState } from '.';

interface EditingLocaleState {
  editingLocaleId?: LocaleResponse['id'];
  referenceLocaleId?: LocaleResponse['id'];
}

export const initialEditingLocaleState: EditingLocaleState = {
  editingLocaleId: undefined,
  referenceLocaleId: undefined,
};

const editingLocale = createSlice({
  name: 'editingLocale',
  initialState: initialEditingLocaleState,
  reducers: {
    setEditingLocaleId: (state, action: PayloadAction<LocaleResponse['id'] | undefined>) => {
      state.editingLocaleId = action.payload;
    },
    setReferenceLocaleId: (state, action: PayloadAction<LocaleResponse['id'] | undefined>) => {
      state.referenceLocaleId = action.payload;
    },
  },
});

export const { setEditingLocaleId, setReferenceLocaleId } = editingLocale.actions;

export default editingLocale.reducer;

export const selectEditingLocaleId = (state: RootState) => state.editingLocale.editingLocaleId;
export const selectReferenceLocaleId = (state: RootState) => state.editingLocale.referenceLocaleId;
